import React from 'react'

import { useParams, useHistory } from 'react-router'
import { format } from 'date-fns'
import { Breadcrumb, BreadcrumbItem } from 'reactstrap'
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next'
// import cookies from 'js-cookie'
import { If, Then, Else } from 'react-if'


import { FindOne } from '../../components/functions/SalarySlip';

// import ErrorSwal from '../../components/SwalError'

const SalaryDetail = () => {

    const { id } = useParams();
    const history = useHistory();
    const { t } = useTranslation()
    // const currentLanguageCode = cookies.get('i18next') || 'en'

    const profileValue = JSON.parse(localStorage.getItem("profile"))
    // console.log(profileValue)
    // const [error, setError] = React.useState(null)
    // const [salaryDetail, setSalaryDetail] = React.useState([])
    // const cancelToken = React.useRef(null)
    const [values, setValues] = React.useState({
        payment_date: (format(new Date(), 'dd/MM/yyyy')),
        income_salary: '-',
        SPECIAL_ALLOWANCE1: '-',
        SPECIAL_ALLOWANCE2: '-',
        SPECIAL_ALLOWANCE3: '-',
        SPECIAL_ALLOWANCE4: '-',
        SPECIAL_ALLOWANCE5: '-',
        SPECIAL_ALLOWANCE6: '-',
        SPECIAL_ALLOWANCE7: '-',
        SPECIAL_ALLOWANCE8: '-',
        SPECIAL_ALLOWANCE9: '-',
        SPECIAL_ALLOWANCE10: '-',
        DEDUCT1: '-',
        DEDUCT2: '-',
        DEDUCT3: '-',
        DEDUCT4: '-',
        DEDUCT5: '-',
        DEDUCT6: '-',
        DEDUCT7: '-',
        DEDUCT8: '-',
        DEDUCT9: '-',
        DEDUCT10: '-',
        ACCU_TAX: '-',
        ACCU_SOCIAL: '-',
        NET_SALARY: '-',
        DEDUCT_TAX: '-',
        LATENESS: '-',
        DEDUCT_TOTAL: '-',
        INCOME_TOTAL: '-',
        INCOME_OT: '-',



    })

    const getData = React.useCallback(async () => {
        try {

            await FindOne(id)
                .then((res) => {
                    // console.log("The Promise is resolved!", res.data.salaries.salaryDetails);
                    setValues({
                        ...values,
                        payment_date: (format(new Date(res.data.salaries.PAYMENT_DATE), 'dd/MM/yyyy')),
                        income_salary: res.data.salaries.salaryDetails.INCOME_SALARY,
                        SPECIAL_ALLOWANCE1: res.data.salaries.salaryDetails.SPECIAL_ALLOWANCE1,
                        SPECIAL_ALLOWANCE2: res.data.salaries.salaryDetails.SPECIAL_ALLOWANCE2,
                        SPECIAL_ALLOWANCE3: res.data.salaries.salaryDetails.SPECIAL_ALLOWANCE3,
                        SPECIAL_ALLOWANCE4: res.data.salaries.salaryDetails.SPECIAL_ALLOWANCE4,
                        SPECIAL_ALLOWANCE5: res.data.salaries.salaryDetails.SPECIAL_ALLOWANCE5,
                        SPECIAL_ALLOWANCE6: res.data.salaries.salaryDetails.SPECIAL_ALLOWANCE6,
                        SPECIAL_ALLOWANCE7: res.data.salaries.salaryDetails.SPECIAL_ALLOWANCE7,
                        SPECIAL_ALLOWANCE8: res.data.salaries.salaryDetails.SPECIAL_ALLOWANCE8,
                        SPECIAL_ALLOWANCE9: res.data.salaries.salaryDetails.SPECIAL_ALLOWANCE9,
                        SPECIAL_ALLOWANCE10: res.data.salaries.salaryDetails.SPECIAL_ALLOWANCE10,
                        DEDUCT1: res.data.salaries.salaryDetails.DEDUCT1,
                        DEDUCT2: res.data.salaries.salaryDetails.DEDUCT2,
                        DEDUCT3: res.data.salaries.salaryDetails.DEDUCT3,
                        DEDUCT4: res.data.salaries.salaryDetails.DEDUCT4,
                        DEDUCT5: res.data.salaries.salaryDetails.DEDUCT5,
                        DEDUCT6: res.data.salaries.salaryDetails.DEDUCT6,
                        DEDUCT7: res.data.salaries.salaryDetails.DEDUCT7,
                        DEDUCT8: res.data.salaries.salaryDetails.DEDUCT8,
                        DEDUCT9: res.data.salaries.salaryDetails.DEDUCT9,
                        DEDUCT10: res.data.salaries.salaryDetails.DEDUCT1,
                        ACCU_TAX: res.data.salaries.salaryDetails.ACCU_TAX,
                        ACCU_SOCIAL: res.data.salaries.salaryDetails.ACCU_SOCIAL,
                        NET_SALARY: res.data.salaries.salaryDetails.NET_SALARY,
                        DEDUCT_TAX: res.data.salaries.salaryDetails.DEDUCT_TAX,
                        LATENESS: res.data.salaries.salaryDetails.LATENESS,
                        DEDUCT_TOTAL: res.data.salaries.salaryDetails.DEDUCT_TOTAL,
                        INCOME_TOTAL: res.data.salaries.salaryDetails.INCOME_TOTAL,
                        INCOME_OT: res.data.salaries.salaryDetails.INCOME_OT,

                    })
                })
                .catch((error) => {
                    history.replace("/dashboard")
                })
                .finally(() => {
                    console.log(
                        "The Promise is settled, meaning it has been resolved or rejected."
                    );
                });

        } catch (error) {
            // setError(error)
            history.replace("/dashboard")
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    React.useEffect(() => {

        getData();
        setTimeout(() => {
        }, 1000);

    }, [getData]);



    return (

        <div className="container-md">
            <div className='mt-5' style={{ paddingLeft: "1.5rem" }}>
                <Breadcrumb listTag="div" >
                    <BreadcrumbItem >
                        <Link to="/salary"> 	{t("t_salary")} </Link>
                    </BreadcrumbItem>
                    <BreadcrumbItem
                        active
                        tag="span"
                    >
                        {id}
                    </BreadcrumbItem>
                </Breadcrumb>
            </div>

            <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div className="card">
                        <div >
                            <div className="card-body">
                                {/* <div className='portlet light bordered'>

                                </div> */}
                                <div className='row'>
                                    <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                        <h4 className="card-title"> {t("t_salary")} </h4>
                                    </div>
                                    <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                        <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                            <p className="card-title">  {t("t_pm_date")} : <span>{values.payment_date}</span> </p>
                                            {/* <p className="card-title">  {values.payment_date} </p> */}
                                        </div>
                                    </div>
                                </div>

                                <div className="table-responsive">
                                    <table className="table table-responsive table-bordered border-primary table-striped text-center" style={{ fontSize: '0.9rem' }}>
                                        <tbody>
                                            <tr>
                                                <th className='text-center' >{t("t_empNo")}</th>
                                                <th className='text-center' colspan="2">{t("t_full_name")}</th>
                                                <th className='text-center' colspan="2">{t("t_position")}</th>
                                                <th className='text-center' colspan="2">{t("t_department")}</th>
                                            </tr>
                                            <tr>
                                                <td className='text-center' >{profileValue.EMP_NO}</td>
                                                <td className='text-center' colspan="2">{profileValue.FULL_NAME}</td>
                                                <td className='text-center' colspan="2">{profileValue.Positions.POSITION_NAME}</td>
                                                <td className='text-center' colspan="2">{profileValue.Departments.DEPTNM}</td>
                                            </tr>
                                            <tr>
                                                <th className='text-center' style={{ verticalAlign: 'middle' }} rowspan="4">{t("t_income")}</th>
                                                <th>{t("t_base_salary")}</th>
                                                <th>
                                                    <If condition={profileValue.Company.SPECIAL_ALLOWANCE1 === "" || profileValue.Company.SPECIAL_ALLOWANCE1 === null}>
                                                        <Then>
                                                            {t("t_SPECIAL_ALLOWANCE1")}
                                                        </Then>
                                                        <Else>
                                                            {profileValue.Company.SPECIAL_ALLOWANCE1}
                                                        </Else>
                                                    </If>
                                                </th>
                                                <th>
                                                    <If condition={profileValue.Company.SPECIAL_ALLOWANCE2 === "" || profileValue.Company.SPECIAL_ALLOWANCE2 === null}>
                                                        <Then>
                                                            {t("t_SPECIAL_ALLOWANCE2")}
                                                        </Then>
                                                        <Else>
                                                            {profileValue.Company.SPECIAL_ALLOWANCE2}
                                                        </Else>
                                                    </If>
                                                </th>
                                                <th>
                                                    <If condition={profileValue.Company.SPECIAL_ALLOWANCE3 === "" || profileValue.Company.SPECIAL_ALLOWANCE3 === null}>
                                                        <Then>
                                                            {t("t_SPECIAL_ALLOWANCE3")}
                                                        </Then>
                                                        <Else>
                                                            {profileValue.Company.SPECIAL_ALLOWANCE3}
                                                        </Else>
                                                    </If>
                                                </th>
                                                <th>
                                                    <If condition={profileValue.Company.SPECIAL_ALLOWANCE4 === "" || profileValue.Company.SPECIAL_ALLOWANCE4 === null}>
                                                        <Then>
                                                            {t("t_SPECIAL_ALLOWANCE4")}
                                                        </Then>
                                                        <Else>
                                                            {profileValue.Company.SPECIAL_ALLOWANCE4}
                                                        </Else>
                                                    </If>
                                                </th>
                                                <th className='text-center'>{t("t_total_income")}</th>
                                            </tr>
                                            <tr>
                                                <td>{values.income_salary}</td>
                                                <td>{values.SPECIAL_ALLOWANCE1}</td>
                                                <td>{values.SPECIAL_ALLOWANCE2}</td>
                                                <td>{values.SPECIAL_ALLOWANCE3}</td>
                                                <td>{values.SPECIAL_ALLOWANCE4}</td>
                                                <th rowspan="3" style={{ verticalAlign: 'middle' }}>{values.INCOME_TOTAL}</th>
                                            </tr>
                                            <tr>
                                                <th>{t("t_ot")}</th>
                                                <th>
                                                    <If condition={profileValue.Company.SPECIAL_ALLOWANCE5 === "" || profileValue.Company.SPECIAL_ALLOWANCE5 === null}>
                                                        <Then>
                                                            {t("t_SPECIAL_ALLOWANCE5")}
                                                        </Then>
                                                        <Else>
                                                            {profileValue.Company.SPECIAL_ALLOWANCE5}
                                                        </Else>
                                                    </If>
                                                </th>
                                                <th>
                                                    <If condition={profileValue.Company.SPECIAL_ALLOWANCE6 === "" || profileValue.Company.SPECIAL_ALLOWANCE6 === null}>
                                                        <Then>
                                                            {t("t_SPECIAL_ALLOWANCE6")}
                                                        </Then>
                                                        <Else>
                                                            {profileValue.Company.SPECIAL_ALLOWANCE6}
                                                        </Else>
                                                    </If>
                                                </th>
                                                <th>
                                                    <If condition={profileValue.Company.SPECIAL_ALLOWANCE7 === "" || profileValue.Company.SPECIAL_ALLOWANCE7 === null}>
                                                        <Then>
                                                            {t("t_SPECIAL_ALLOWANCE7")}
                                                        </Then>
                                                        <Else>
                                                            {profileValue.Company.SPECIAL_ALLOWANCE7}
                                                        </Else>
                                                    </If>
                                                </th>
                                                <th>
                                                    <If condition={profileValue.Company.SPECIAL_ALLOWANCE8 === "" || profileValue.Company.SPECIAL_ALLOWANCE8 === null}>
                                                        <Then>
                                                            {t("t_SPECIAL_ALLOWANCE8")}
                                                        </Then>
                                                        <Else>
                                                            {profileValue.Company.SPECIAL_ALLOWANCE8}
                                                        </Else>
                                                    </If>
                                                </th>
                                            </tr>
                                            <tr>
                                                <td>{values.INCOME_OT}</td>
                                                <td>{values.SPECIAL_ALLOWANCE5}</td>
                                                <td>{values.SPECIAL_ALLOWANCE6}</td>
                                                <td>{values.SPECIAL_ALLOWANCE7}</td>
                                                <td>{values.SPECIAL_ALLOWANCE8}</td>
                                            </tr>
                                            <tr>
                                                <th className='text-center' style={{ verticalAlign: 'middle' }} rowspan="4">{t("t_money_deducted")}</th>
                                                <th className='text-center'>{t("t_tax")}</th>
                                                <th>
                                                    <If condition={profileValue.Company.DEDUCTION1 === "" || profileValue.Company.DEDUCTION1 === null}>
                                                        <Then>
                                                            {t("t_DEDUCTION1")}
                                                        </Then>
                                                        <Else>
                                                            {profileValue.Company.DEDUCTION1}
                                                        </Else>
                                                    </If>
                                                </th>
                                                <th>
                                                    <If condition={profileValue.Company.DEDUCTION2 === "" || profileValue.Company.DEDUCTION2 === null}>
                                                        <Then>
                                                            {t("t_DEDUCTION2")}
                                                        </Then>
                                                        <Else>
                                                            {profileValue.Company.DEDUCTION2}
                                                        </Else>
                                                    </If>
                                                </th>
                                                <th>
                                                    <If condition={profileValue.Company.DEDUCTION3 === "" || profileValue.Company.DEDUCTION3 === null}>
                                                        <Then>
                                                            {t("t_DEDUCTION3")}
                                                        </Then>
                                                        <Else>
                                                            {profileValue.Company.DEDUCTION3}
                                                        </Else>
                                                    </If>
                                                </th>
                                                <th>
                                                    <If condition={profileValue.Company.DEDUCTION4 === "" || profileValue.Company.DEDUCTION4 === null}>
                                                        <Then>
                                                            {t("t_DEDUCTION4")}
                                                        </Then>
                                                        <Else>
                                                            {profileValue.Company.DEDUCTION1}
                                                        </Else>
                                                    </If>
                                                </th>
                                                <th className='text-center'>{t("t_total_deduction")}</th>
                                            </tr>
                                            <tr>
                                                <td>{values.DEDUCT_TAX}</td>
                                                <td>{values.DEDUCT1}</td>
                                                <td>{values.DEDUCT2}</td>
                                                <td>{values.DEDUCT3}</td>
                                                <td>{values.DEDUCT4}</td>
                                                <th rowspan="3" style={{ verticalAlign: 'middle' }}>{values.DEDUCT_TOTAL}</th>
                                            </tr>
                                            <tr>
                                                <th className='text-center'>{t("t_late")}</th>
                                                <th>
                                                    <If condition={profileValue.Company.DEDUCTION5 === "" || profileValue.Company.DEDUCTION5 === null}>
                                                        <Then>
                                                            {t("t_DEDUCTION5")}
                                                        </Then>
                                                        <Else>
                                                            {profileValue.Company.DEDUCTION5}
                                                        </Else>
                                                    </If>
                                                </th>
                                                <th>
                                                    <If condition={profileValue.Company.DEDUCTION6 === "" || profileValue.Company.DEDUCTION6 === null}>
                                                        <Then>
                                                            {t("t_DEDUCTION6")}
                                                        </Then>
                                                        <Else>
                                                            {profileValue.Company.DEDUCTION6}
                                                        </Else>
                                                    </If>
                                                </th>
                                                <th>
                                                    <If condition={profileValue.Company.DEDUCTION7 === "" || profileValue.Company.DEDUCTION7 === null}>
                                                        <Then>
                                                            {t("t_DEDUCTION7")}
                                                        </Then>
                                                        <Else>
                                                            {profileValue.Company.DEDUCTION7}
                                                        </Else>
                                                    </If>
                                                </th>
                                                <th>
                                                    <If condition={profileValue.Company.DEDUCTION8 === "" || profileValue.Company.DEDUCTION8 === null}>
                                                        <Then>
                                                            {t("t_DEDUCTION8")}
                                                        </Then>
                                                        <Else>
                                                            {profileValue.Company.DEDUCTION8}
                                                        </Else>
                                                    </If>
                                                </th>
                                            </tr>
                                            <tr>
                                                <td>{values.LATENESS}</td>
                                                <td>{values.DEDUCT5}</td>
                                                <td>{values.DEDUCT6}</td>
                                                <td>{values.DEDUCT7}</td>
                                                <td>{values.DEDUCT8}</td>
                                            </tr>
                                            <tr>
                                                <th colspan="2">{t("t_account_number")}</th>
                                                <th >{t("t_accu_tax")}</th>
                                                <th >{t("t_accu_social")}</th>
                                                <th ></th>
                                                <th ></th>
                                                <th >{t("t_net_income")}</th>
                                            </tr>
                                            <tr>
                                                <td colspan="2">-</td>
                                                <td>{values.ACCU_TAX}</td>
                                                <td>{values.ACCU_SOCIAL}</td>
                                                <td ></td>
                                                <td ></td>
                                                <th>{values.NET_SALARY}</th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>


    )
}

export default SalaryDetail